module.exports = {
  personalProjects: [
    {
      title: "My BNB",
      description:
        "MyBNB is trying to disrupt the hotel industry. I could have said this only if this was my original idea. For more please visit the github repo.",
      tools: ["Vue", "Vutify", "tailwind css", "firebase", "netlify"],
      demo:
        "https://mybnb007.netlify.app/",
      code: "https://github.com/negimohit1209/My_bnb",
      img: "personalProjects/mybnb1.png"
    },
  ],
  humbleschool: [
    {
      title: "Madam Curious",
      description:
        "Madam Curious is a native app build using Flutter. We believe starting early is the key to making JEE preparation easy and fun. Developed authentication, push notification using FCM and the beautiful UI.",
      tools: ["Flutter", "Dart", "firebase"],
      demo:
        "https://play.google.com/store/apps/details?id=school.humble.madam_curious",
      code: "https://apps.apple.com/us/app/madam-curious/id1464114406",
      img: "humbleschool/madam.png"
    },
    {
      title: "Madam Curious Admin",
      description:
        "Madam Curious Admin is the app used for the content creation and managing the user of the native app.",
      tools: ["Vue", "Buefy", "firebase", "Algolia", "Node"],
      demo: "https://www.madamcurious.com/",
      code: "https://www.madamcurious.com/",
      img: "humbleschool/admin.png"
    }
  ],
  web_apps: [
    {
      title: "Hostel Management System",
      description:
        "Final Year Web Technology Project. The app makes the hostel admission process smooth as silk. The roles are defined for Admin, warden and students.",
      tools: ["node/express", "MongoDB", "ejs", "passport.js"],
      demo: "https://thawing-ridge-47496.herokuapp.com",
      code: "https://github.com/negimohit1209/hostelManagementSystem",
      img: "web_apps/hostel.jpg"
    },
    {
      title: "Auction Dashboard",
      description:
        "Auctioning process of Players in IFL could not be more smoother. One stop destination for player registration and auctioning.",
      tools: ["react", "node/express", "mongodb", "material-ui", "passport"],
      demo:
        "https://medium.com/@mohitsngh1997/iiest-football-league-auction-dashboard-b1ad03a3afdf",
      code: "https://github.com/negimohit1209/AuctionDashboard",
      img: "web_apps/auction.png"
    },
    {
      title: "Chat App",
      description:
        "Chat app build was a part of the Node.js course by Andrew Mead, I took on Udemy.",
      tools: ["socket.io", "node.js", "mustache.js"],
      demo: "https://hidden-chamber-91109.herokuapp.com/",
      code: "https://github.com/negimohit1209/node-socket.io-chatApp",
      img: "web_apps/chat1.jpg"
    },
    {
      title: "HireIT",
      description:
        "HireIT is an App built for recruiting purpose. Do have a look if you want to hire talent.",
      tools: ["React", "Redux", "firebase", "Material UI"],
      demo: "https://hireit-124.web.app/",
      code: "https://github.com/negimohit1209/hiring_app",
      img: "web_apps/hireit.png"
    },
    {
      title: "Man City Fan",
      description:
        "Manchester city is 4 time Premier League Champions. But this year is a little depressing with Liverpool winning EPL and UCL 2 year ban 😥. But we will comeback stronger.",
      tools: ["html", "css", "React", "firebase"],
      demo: "https://man-city-57a5d.firebaseapp.com/",
      code: "https://github.com/negimohit1209/manchester_city_fanApp",
      img: "web_apps/city.png"
    },
    {
      title: "Yelp Camp",
      description:
        'This was my first complete app that I have build. It is code along project of "The web developer bootcamp" by Colt Steele.',
      tools: ["Node", "Express", "MongoDb", "ejs", "passport.js", "Bootstrap"],
      demo: "https://damp-garden-11012.herokuapp.com",
      code: "https://github.com/negimohit1209/Campers-Guide",
      img: "web_apps/yelpcamp.png"
    },

    {
      title: "Burger Builder",
      description:
        "A react app in which a customer can register and buy a delicious burger. Used firebase as a database.",
      tools: ["react", "redux", "webpack", "node/express", "firebase"],
      demo: "#",
      code: "https://github.com/negimohit1209/Burger_builder",
      img: "web_apps/burger.jpg"
    },

    {
      title: "Weather monitoring system",
      description:
        "Personalised weather monitoring system using NodeMCU ESP8266 and a supporting web application. Because who doesn't like to know their room's temperature and humidity.😉",
      tools: [
        "html",
        "css",
        "React",
        "Redux",
        "Material UI",
        "nodeMCU",
        "ESP8266"
      ],
      demo: "https://weather-monitoring-system.herokuapp.com",
      code: "https://github.com/negimohit1209/weather_monitoring_station",
      img: "web_apps/weather.png"
    },
    {
      title: "Stock Trading App",
      description:
        "Stock trading app is web app build to simulate the work flow of stock trading. You can buy and sell your stocks. App was a course project in 'Vue JS 2 - The Complete Guide by Maximilian Schwarzmüller'🤑",
      tools: ["html", "css", "Vue", "Vuex", "firebase"],
      demo: "https://vuejstradingapp.web.app/",
      code: "https://github.com/negimohit1209/vuejs_stock_trader",
      img: "web_apps/stock.png"
    },
    {
      title: "Color Game",
      description:
        "Do you have the talent of identifying a color just by looking at it's rgb values. Give it a shot. :)",
      tools: ["html", "css", "javascript", "jquery"],
      demo: "https://codepen.io/negimohit1209/full/dzmgrj",
      code: "https://github.com/negimohit1209/Color-Identifying-Game",
      img: "web_apps/color.jpg"
    }
  ],

  api_microservices: [
    {
      title: "Travelville",
      description: "A landing page build with materialize CSS.",
      demo: "https://ij-img-search.glitch.me/",
      code: "https://github.com/negimohit1209/materialize_css_landingpage",
      img: "api_microservices/travel.png"
    },
    {
      title: "TV search engine",
      description: "Search for TV shows using API.",
      demo: "https://github.com/negimohit1209/TV_searchEngine_React",
      code: "https://github.com/negimohit1209/TV_searchEngine_React",
      img: "api_microservices/react.png"
    },
    {
      title: "Random Quote",
      description: "Displays a random Quote for the day",
      demo: "https://github.com/negimohit1209/TV_searchEngine_React",
      code: "https://github.com/negimohit1209/TV_searchEngine_React",
      img: "api_microservices/random.png"
    },
    {
      title: "Todo List",
      description: "A course project of web developer bootcamp",
      demo: "https://codepen.io/negimohit1209/project/editor/DNKYEJ",
      code: "https://github.com/negimohit1209/TODO-list",
      img: "api_microservices/todo.png"
    },
    {
      title: "Pixabay Image Search",
      description: "Image searching app using Pixabay API",
      demo: "https://boiling-inlet-69037.herokuapp.com/",
      code: "https://github.com/negimohit1209/pixabayImageSearch",
      img: "api_microservices/pixabay.png"
    },
    {
      title: "Purrfect Match",
      description: "Homepage for a tinder like app for animal.",
      demo: "https://codepen.io/negimohit1209/full/MvKVLK",
      code: "https://github.com/negimohit1209/pixabayImageSearch",
      img: "api_microservices/cat2.png"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/data/projectsData.js